import Vue from 'vue'
import cWindow from './index.vue'
import {store} from '../../main'

Vue.component('window', cWindow);

Vue.prototype.$window = function ({title, slot, close, visible}) {
    let vm = new Vue({
        data: {
            title,
            slot,
            visible,
        },
        store,
        methods: {
            close,
        },
        render(c) {
            if (this.visible&&this.slot) {
                return c(
                    'el-dialog', {
                        staticClass: "window",
                        attrs: {visible: this.visible, title: this.title},
                        on: {close: this.close}
                    },
                    [this.slot]
                )
            }
        },
        destroyed() {
            document.body.removeChild(this.$el);
        },
    });
    document.body.appendChild(vm.$mount().$el);
    return vm;
};

